import "./App.css";
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <Dictionary defaultKeyword="Hello" />
      <footer>
        This page was coded by Markita Lilly and is open-sourced on{" "}
        <a
          href="https://github.com/kikicod3r/Dictionary-App"
          target="_blank"
          rel="noreferrer"
        >
          Github
        </a>
      </footer>
    </div>
  );
}

export default App;
